export default "__VITE_ASSET__Cvfa2WdU__"